import { Link } from "react-router";
import { navRoutes } from "@/routes";
import { useSite } from "@/lib/useSite";

export function SiteFooter() {
  const site = useSite();
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        {/* "Copywrong" is inherited from the original site, on purpose. */}
        <p>
          Created and maintained by Lucas Farmer · Copywrong © {new Date().getFullYear()}
        </p>
        <a href="mailto:lucas@lucasfarmer.com" className="footer-contact">
          <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <rect x="3" y="5" width="18" height="14" rx="2" />
            <path d="m3 7 9 6 9-6" />
          </svg>
          Contact
        </a>
        <nav className="row row--wrap" aria-label="Footer">
          {navRoutes("site", site)
            .filter((r) => r.path !== "/")
            .map((r) => (
              <Link key={r.path} to={r.path} className="nav-link">
                <span className="tag">{r.label}</span>
              </Link>
            ))}
        </nav>
      </div>
    </footer>
  );
}
